import React from "react";

const TrustedByCustomers = () => {
  return (
    <section className="bg-gradient-to-b from-white to-amber-50 px-4 py-10 sm:py-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Card-style container */}
        <div className="rounded-3xl border border-amber-200 bg-amber-50 p-6 shadow-sm sm:p-10">
          <p className="mb-2 text-xs font-bold uppercase tracking-[0.18em] text-blue-800">
            Good trips, shared
          </p>
          <h2 className="mb-4 text-2xl font-bold leading-tight text-stone-900 sm:text-3xl">
            Trusted by Thousands of Customers
          </h2>
          <p className="mx-auto mb-6 max-w-md text-sm text-stone-600 sm:mb-8 sm:text-base">
            See what fellow travellers say about their experiences with
            SKAdventures.
          </p>

          <div>
            <button
              onClick={() =>
                window.open("https://share.google/RdOEODAyEH03uCeO1", "_blank")
              }
              className="w-full rounded-full bg-blue-800 px-6 py-3 text-sm font-semibold text-white shadow-sm transition duration-300 hover:bg-blue-900 sm:w-auto sm:text-base"
            >
              See Reviews
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedByCustomers;
